import { cn } from "@omni/utils/styles";
import { SingleValue } from "react-select";

import { Select } from "@/components/Form/Base/select.component";
import { useFaqContext } from "@/components/General/Faq/context/faq.context";
import { FaqCategory } from "@/components/General/Faq/types/faqCategory.types";

type Props = {
    className?: string;
};

export const CategoriesSelect = ({ className }: Props) => {
    const { categories, selection, onSelectCategory } = useFaqContext();

    const options = categories.map((category) => ({
        label: category.title,
        value: category
    }));

    const handleOnChange = (newValue: SingleValue<{ value: FaqCategory }>) => {
        if (!newValue) return;
        if (selection.category.alias === newValue.value.alias) return;

        onSelectCategory(newValue.value);
    };

    return (
        <Select
            className={cn(className)}
            openMenuOnFocus={true}
            options={options}
            isSearchable={true}
            blurInputOnSelect={true}
            value={{
                label: selection.category.title,
                value: selection.category
            }}
            onChange={handleOnChange}
        />
    );
};
